import _toConsumableArray from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export var PAGE_SIZE = 8;
var processGames = function processGames(props) {
  var _activeGameRoom$games;
  var activeGameRoom = props.activeGameRoom,
    userLevel = props.userLevel,
    gameInfo = props.gameInfo;
  if (!(activeGameRoom !== null && activeGameRoom !== void 0 && (_activeGameRoom$games = activeGameRoom.games) !== null && _activeGameRoom$games !== void 0 && _activeGameRoom$games.length)) return {
    panelList: [],
    pagedGames: [],
    pageNumber: 0,
    gameIndex: 0
  };
  var panelList = activeGameRoom.games.filter(function (game) {
    return !game.IS_HIDDEN;
  });
  var pagedGames = [];
  var pageNumber = 0;
  var gameIndex = 0;
  var getGameIndex = function getGameIndex(pageIndex, gameIndexOnPage) {
    var gamesPerRow = PAGE_SIZE / 2;
    var baseIndex = pageIndex * gamesPerRow;
    var indexWithinRow = gameIndexOnPage % gamesPerRow;
    return baseIndex + indexWithinRow;
  };
  pagedGames = panelList.reduce(function (acc, curr, index) {
    var pageIndex = Math.floor(index / PAGE_SIZE);
    if (!acc[pageIndex]) acc[pageIndex] = [];
    acc[pageIndex].push(curr);
    return acc;
  }, []).map(function (gamePage) {
    var _gamePage$reduce = gamePage.reduce(function (_ref, game, index) {
        var _ref2 = _slicedToArray(_ref, 2),
          even = _ref2[0],
          odd = _ref2[1];
        (index % 2 === 0 ? even : odd).push(game);
        return [even, odd];
      }, [[], []]),
      _gamePage$reduce2 = _slicedToArray(_gamePage$reduce, 2),
      evenIndexItems = _gamePage$reduce2[0],
      oddIndexItems = _gamePage$reduce2[1];
    return [].concat(_toConsumableArray(evenIndexItems), _toConsumableArray(oddIndexItems));
  });
  pagedGames.some(function (page, pageIndex) {
    return page.some(function (game, gameIndexOnPage) {
      if (game.GAME_ID === gameInfo.lastGameVisited) {
        pageNumber = pageIndex;
        gameIndex = getGameIndex(pageIndex, gameIndexOnPage);
        return true;
      } else if (game.UNLOCK_LEVEL <= userLevel) {
        pageNumber = pageIndex;
        gameIndex = getGameIndex(pageIndex, gameIndexOnPage) - 1;
      }
      return false;
    });
  });
  return {
    panelList: panelList,
    pagedGames: pagedGames,
    pageNumber: pageNumber,
    gameIndex: gameIndex
  };
};
export default processGames;